export class MobileSliderComponent extends HTMLElement {
  constructor() {
    super()
    this.swiperLoaded = false
  }

  async loadSwiper() {
    if (this.swiperLoaded) return

    // Load Swiper CSS
    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css'
    document.head.appendChild(link)

    // Load Swiper JS
    const script = document.createElement('script')
    script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js'

    await new Promise((resolve, reject) => {
      script.onload = resolve
      script.onerror = reject
      document.head.appendChild(script)
    })

    this.swiperLoaded = true
  }

  connectedCallback() {
    this.init()
  }

  async init() {
    await this.loadSwiper()

    const container = this.querySelector('.mobile-swiper')
    const swiper = new Swiper(container, {
      speed: 600,
      loop: true,
      slidesPerView: 1.5,
      spaceBetween: 12,
      slidesOffsetBefore: 12
      // breakpoints: {
      //   1024: {
      //     slidesPerView: 4
      //   }
      // }
    })
    console.log('Mobile Slider initialized', swiper)
  }
}

customElements.define('mobile-slider-component', MobileSliderComponent)
